import { cx, dateFormat } from '@/utils/strings'
import ImageContentful from '@/components/ui/image-contentful'
import LinkComponent from '@/components/link-component'
import AngleRightIcon from '@/icons/bwi/angle-right.svg'

export type ArticleCardProps = {
  description?: string
  image: any
  title: string
  publishDate?: string
  readTime?: number
  url: string
  cta?: string
}

export default function ArticleListCard({
  description,
  image,
  title,
  publishDate,
  readTime,
  url,
  cta,
}: ArticleCardProps) {
  return (
    <LinkComponent
      to={`${url}`}
      className={cx(
        'rounded-4xl transition-all duration-[250ms] md:hover:bg-white md:hover:shadow-even-around md:hover:scale-x-[1.02] md:hover:scale-y-[1.02] dark:md:hover:shadow-2xl dark:md:hover:bg-secondary-900 dark:md:hover:scale-x-[1.02] dark:md:hover:bg-transparent '
      )}
    >
      <article className="mb-12 lg:mb-8 md:p-4">
        <div className="relative">
          {image && image?.fields?.file?.contentType !== 'image/svg+xml' && (
            <div className="rounded-[1.8rem] [&>*]:aspect-video overflow-hidden aspect-video">
              <ImageContentful className="m-auto h-full object-cover" {...image?.fields} />
            </div>
          )}
          {image?.fields?.file?.contentType === 'image/svg+xml' && (
            <div className="flex items-center rounded-[1.8rem] w-full bg-primaryBlue aspect-video overflow-hidden">
              <ImageContentful className="[&_svg]:w-1/2 [&_svg]:m-auto" {...image?.fields} />
            </div>
          )}
          {!image && (
            <div className="aspect-video rounded-[1.8rem] bg-primaryBlue text-center flex items-center justify-center">
              <span className="font-bwi text-[100px] text-white">&#xe932;</span>
            </div>
          )}
          <div className="rounded-full p-3 h-12 w-12 bg-white opacity-80 flex items-center justify-center absolute bottom-4 right-4">
            <AngleRightIcon className="ml-1 text-md" />
          </div>
        </div>

        <div className="text-indigoBlue px-4 md:px-6 dark:text-white">
          {(publishDate || readTime) && (
            <div className="my-4 flex space-x-4 justify-between text-secondary-500">
              <div>{publishDate && <time>{dateFormat(publishDate, 'en-US')}</time>}</div>
              {readTime && <span>{readTime} min read</span>}
            </div>
          )}
          {title && <h2 className={cx('text-xl leading-6 mb-0', !publishDate && !readTime && 'mt-4')}>{title}</h2>}
          {description && <p className="font-thin line-clamp-3 mt-4">{description}</p>}
          {cta && (
            <p className="text-primaryBlue font-bold text-sm mt-4 mb-0 flex items-center gap-2">
              {cta} <AngleRightIcon className="w-3 h-3 stroke-primaryBlue stroke-2" />
            </p>
          )}
        </div>
      </article>
    </LinkComponent>
  )
}
